export default function (date: string) {
  // spilt data string into date and time, then select only the date and split that by a -
  const rawDate = date.split('T')[0].split('-')
  // remove the year from the beginning of the date array and push to the end
  const year = rawDate.shift()
  if (year) rawDate.push(year)

  return rawDate.join('/')
}
